import React from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import {UploadSchemaContext} from "./context/UploadSchemaContext";
import SchemaMetadataWidget from "../../widgets/schema-metadata/SchemaMetadataWidget";
import SchemaInformationWidget from "../../widgets/schema-information/SchemaInformationWidget";
import {WizardStepProps} from "../../wizard/Wizard";
import {UnsavedChangesConfirmation} from "../../../common/NavigationConfirmation";
import {UploadSchemaWizardLeavingConfirmationMessage} from "./UploadSchemaWizard";
import Loader from "../../loader/Loader";
import OpenSchemaAction from "../actions/OpenSchemaAction";

/**
 * Step implementation dealing with schema activation.
 */
class ActivateSchemaStep extends React.Component<WizardStepProps> {

  static contextType = UploadSchemaContext;

  onActivate = () => {
    const result = this.context.activateSchema(this.context.schemaId);
    return this.props.next(result);
  };

  onSkipActivation = () => {
    return this.props.next(true);
  };

  render() {
    const loader = this.context.isRequestRunning ? <Loader/> : false;
    const actionsDisabled = this.context.isRequestRunning;
    return (
      <>
        <Container className="ActivateSchemaStep no-padding" fluid>
          <Row className="pb-3">
            <Col>
              <div className="StepActions">
                <OpenSchemaAction schema={this.context.schemaId} standardButton={true} disabled={actionsDisabled} />
                <Button className="activate-schema next-btn"
                        disabled={actionsDisabled || !this.context.permissions?.canBind}
                        onClick={this.onActivate}
                        title={this.context.permissions?.canBind ? "Activate Schema" : "Activate schema is forbidden"}>
                  Activate
                </Button>
                <Button className="skip-activation"
                        disabled={actionsDisabled}
                        onClick={this.onSkipActivation}
                        title="Skip activation">
                  Skip activation
                </Button>
                {loader}
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <SchemaMetadataWidget schema={this.context.schemaYaml}
                                    loading={this.context.loading}/>
            </Col>
            <Col>
              <SchemaInformationWidget schema={this.context.schemaYaml}
                                       loading={this.context.loading}/>
            </Col>
          </Row>
        </Container>
        <UnsavedChangesConfirmation when={true}
                                    message={UploadSchemaWizardLeavingConfirmationMessage}/>
      </>
    );
  }
}

export default ActivateSchemaStep;
